import { render, staticRenderFns } from "./SubmitConfirmation.vue?vue&type=template&id=03bc161a"
import script from "./SubmitConfirmation.vue?vue&type=script&lang=js"
export * from "./SubmitConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports